<template>
  <div class="Wdgt-Content-Hdr">
    <div class="Wdgt-Content-Hdr__box">
      <button class="Wdgt-Content-Hdr__author" @click="goToUser" v-if="get_isShowAuthor">
        <AvatarImage class="Wdgt-Content-Hdr__avt" :src="DATA.author.avatar" :size="16" /> {{ DATA.author.name }}
      </button>
      <time class="Wdgt-Content-Hdr__time">{{ get_time }}</time>
      <a class="Wdgt-Content-Hdr__lnk" target="_blank" :href="get_source" v-if="get_source">
        <span class="Wdgt-Content-Hdr__lnk-txt">{{ get_source }}</span>
        <LinkIconRadius class="Wdgt-Content-Hdr__icon" />
      </a>
    </div>
    <div class="Wdgt-Content-Hdr__box">
      <CounterComment
        class="Wdgt-Content-Hdr__cloud"
        :class="get_disabledCloudBtn"
        v-if="get_isShowCommentsCounter"
        :count="DATA.init_comments_count"
        :newCommentsCounter="DATA.comments_count"
        :isClickable="true"
        @click="goToComments"
      />
      <PostMenu class="Wdgt-Content-Hdr__menu" :postId="DATA.id" v-if="get_isShowMenu"/>
      <a class="Wdgt-Content-Hdr__news-admin" :href="DATA.admin_link" v-if="get_hasModeratorPrivileges">
        <PenIcon />
      </a>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  import { formatTime_h_min_dn, formatTime_dn_mn_y } from '@shared/utils/time/formated';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
  //------------------------------
  import LinkIconRadius from '@svg/LinkIconRadius.vue';
  import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
  import CounterComment from '@ui/Counters/CounterComment/CounterComment.vue';
  import PostMenu from '@entities/Posts/PostMenu/PostMenu.vue';
  import PenIcon from '@shared/UI/SVG/PenIcon.vue';
  //------------------------------
  const store = useStore();
  const props = defineProps(Props());
  const router = useRouter();
  const emit = defineEmits(['go-to-comments']);
  //------------------------------
  const DATA = props.post;
  const POPUP_NAME = DROPDOWN_NAMES.contentPage;
  //------------------------------
  //Получить форматированное время публикации
  const get_time = computed(() => {
    const pubDate = new Date(DATA.publication_date);
    const currentYear = new Date().getFullYear();

    if (pubDate.getFullYear() === currentYear) {
      return formatTime_h_min_dn(DATA.publication_date);
    } else {
      return formatTime_dn_mn_y(DATA.publication_date);
    }
  });
  //Получить кол-во комментариев
  const get_commentsCount =  computed(() => DATA.comments_count);
  //Отображать ли счетчик комментариев
  const get_isShowCommentsCounter = computed(() => get_commentsCount.value > 0);
  //Получить источник информации
  const get_source = computed(() => DATA.source);
  //Пользователь имеет доступа к закрытому контенту
  const get_hasPaidAccount = computed(() => store.getters['UserSystem/hasPaidAccess']);
  //Пользовтаель имеет права модерирования
  const get_hasModeratorPrivileges = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
  //Заблокировать кнопку перемещения к комментариям для неавторизированного пользьователя в Альфе
  const get_disabledCloudBtn = computed(() => !get_hasPaidAccount.value ? 'Wdgt-Content-Hdr__cloud--disabled' : '');
  //Получить словарь инфошума
  const get_news = computed(() => store.state.ContentSystem.Infonoise.list);
  //Отображать ли информацию об авторе
  const get_isShowAuthor = computed(() => {
    return !get_news.value.hasOwnProperty(DATA.id) && DATA.section_name !== 'podcast';
  });
  //Отображать ли контекстное меню
  const get_isShowMenu = computed(() => get_hasPaidAccount.value && !get_news.value.hasOwnProperty(DATA.id));
  //Получить объект перехода
  const get_pathObj = computed(() => {
    return (DATA.author.username === store.state.UserSystem.user.username) ?
      { name: PATHS_NAME.USER.SETTINGS} :
      { name: PATHS_NAME.OTHER_USERS.PROFILE, params: { username: DATA.author.username } };
  });
  //------------------------------
  //Переместиться к комементариям
  const goToComments = () => emit('go-to-comments');
  //Переместить на страницу пользователя
  const goToUser = () => {
    store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
    router.push(get_pathObj.value);
  };
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
